import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {GetBaseContext as GetBaseContextQuery} from 'nutshell-graphql-types';

import {generateContextString} from '../../helpers';

import GET_BASE_CONTEXT from '../queries/get-base-context.graphql';

export const useGetBaseContext = (): {
    baseContext: string | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<GetBaseContextQuery, Record<any, any>>(
        GET_BASE_CONTEXT,
        {}
    );

    return {
        baseContext: generateContextString(data),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
